import { useTranslation } from 'react-i18next';
import styles from './WidgetStyles.module.css';
import { CloseIcon, DockIcon, UndockIcon } from './WidgetIcons';
import skfLogo from '../resources/skf-logo-black.svg';

export type WidgetHeaderProps = {
    brandLabel: string;
    isDocked: boolean;
    onToggleDock: () => void;
    onClose?: () => void;
    dockingEnabled?: boolean;
};

export function WidgetHeader({
    brandLabel,
    isDocked,
    onToggleDock,
    onClose,
    dockingEnabled = true
}: WidgetHeaderProps) {
    const { t } = useTranslation();
    const showDockButton = dockingEnabled !== false;

    return (
        <header className={styles.widgetHeader}>
            <div className={styles.brandLogo} aria-label={`${brandLabel} brand logo`}>
                <img src={skfLogo} alt={brandLabel} className={styles.brandLogoImage} />
            </div>
            <div className={styles.topBarActions} role="group" aria-label="Widget window controls">
                {showDockButton ? (
                    <button
                        className={`${styles.topBarButton} ${styles.dockButton}`}
                        part="dock-button"
                        data-skf-part="dock-button"
                        type="button"
                        aria-label={isDocked ? t('undockWidget') : t('dockWidget')}
                        title={isDocked ? t('undockWidget') : t('dockWidget')}
                        onClick={onToggleDock}
                        aria-pressed={isDocked}
                    >
                        {isDocked ? <UndockIcon /> : <DockIcon />}
                    </button>
                ) : null}
                <button
                    className={`${styles.topBarButton} ${styles.closeButton}`}
                    type="button"
                    aria-label={t('closeWidget')}
                    title={t('closeWidget')}
                    onClick={() => onClose?.()}
                    disabled={!onClose}
                >
                    <CloseIcon />
                </button>
            </div>
        </header>
    );
}
